import React from 'react';
import Footer from '@ajat/design-system/Footer';
import useMenuItemNavigation from '../../../../hooks/useMenuItemNavigation';
import useMenuItemVisibility from '../../../../hooks/useMenuItemVisibility';

/* ══════════════════════════════════════════════════════════════════════════
 * ABC-SE — Common Footer
 * Single source of truth for footer configuration across all ABC-SE pages
 * ══════════════════════════════════════════════════════════════════════════ */
const legalLinks = [
  { label: 'Köpvillkor', href: '/clothing/abc-se/terms' },
  { label: 'Personuppgiftspolicy', href: '/clothing/abc-se/privacy' },
];

const socials = [
  { icon: 'facebook', href: 'https://www.facebook.com/abcgruppen/', ariaLabel: 'Facebook' },
  { icon: 'instagram', href: 'https://www.instagram.com/abcgruppen/', ariaLabel: 'Instagram' },
  { icon: 'youtube', href: 'https://www.youtube.com/channel/UC3nwR2BvP76_SQcvd8bbK_A', ariaLabel: 'YouTube' },
];

const contact = {
  title: 'KONTAKTA OSS',
  email: { label: 'kundservice@abcgruppen.se', href: 'mailto:kundservice@abcgruppen.se' },
  address: ['Sibyllegatan 47, 1 tr,', 'SE-114 42 Stockholm, Sverige'],
};

export const copyright = `© ${new Date().getFullYear()} ABC-Gruppen AB, All Rights Reserved`;

const ABCSEFooter = (props) => {
  const onMenuItemClick = useMenuItemNavigation({ brandSlug: 'abcse', feSlug: 'abc-se' });
  const { isVisible } = useMenuItemVisibility('abcse');

  const columns = [
    {
      title: 'BEHÖVER DU HJÄLP?',
      links: [
        { label: 'Kundservice', href: '/clothing/abc-se/faq' },
        { label: 'Storleksguide', href: '/clothing/abc-se/size-guide' },
        { label: 'Kontakta oss', href: '/clothing/abc-se/contact' },
      ],
    },
    {
      title: 'ABC-GRUPPEN',
      links: [
        { label: 'Skolmerch', menuKey: 'menu_1', href: '#', onClick: (e) => { e.preventDefault(); onMenuItemClick('menu_1'); } },
        { label: 'Overalls & More', menuKey: 'menu_2', href: '#', onClick: (e) => { e.preventDefault(); onMenuItemClick('menu_2'); } },
        { label: 'Studentmössor', href: 'https://www.abcgruppen.se/' },
      ],
    },
  ].map((col) => ({
    // Same visibility rule as the header menu items ("Disable Open Shop").
    ...col,
    links: col.links.filter((l) => !l.menuKey || isVisible(l.menuKey)),
  }));

  return (
    <Footer brand="ABC" columns={columns} legalLinks={legalLinks} socials={socials} contact={contact} copyright={copyright} {...props} />
  );
};

export default ABCSEFooter;
